import React from 'react';
import { joinClasses } from 'components/utils/react_helper';

export default (props) => {
  const onIncreaseQuantity = (e) => {
    e.preventDefault();
    props.increaseQuantity(e);
  };

  const onDecreaseQuantity = (e) => {
    e.preventDefault();
    props.decreaseQuantity(e);
  };

  return (
    <div className="counter">
      {props.label && (
        <p className={joinClasses(['counter__label', props.leftAligned && 'counter__label--left-aligned'])}>
          {props.label}
        </p>
      )}

      <div className={joinClasses(['counter__inner', props.leftAligned && 'counter__inner--left-aligned'])}>
        <button className="counter__button counter__button--decrease" onClick={onDecreaseQuantity}>
          <span className="counter__button-text">-</span>
        </button>

        <span className="counter__quantity">{props.quantity}</span>

        <button className="counter__button counter__button--increase" onClick={onIncreaseQuantity}>
          <span className="counter__button-text">+</span>
        </button>
      </div>
    </div>
  );
};
